import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dt from '../../shared/theme';

const Container = styled.p`
  margin: 64px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  > span {
    color: ${props => dt(props).theme.secondaryColor};
    text-transform: uppercase;
    font-family: ${props => dt(props).theme.fontFamilyBody};
    font-weight: ${props => dt(props).theme.fontWeightHeavy};
    font-size: 16px;
    line-height: 16px;
  }
`;

export default function InfiniteScrollEndText({ text }) {
  return (
    <Container>
      <span>{text}</span>
    </Container>
  );
}

InfiniteScrollEndText.propTypes = {
  text: PropTypes.string.isRequired,
};
